/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_journeycourse.js                                                                  */
/**********************************************************************************************************************/

HafasWebapp.prototype.Controller.JourneyCourse = {
  currentJourneyCourse:null,
  journeyCourseContainer:null,
  startJourneyCourse: function(){
      //console.dir(this.Controller.JourneyCourse);
      if(this.Controller.JourneyCourse.currentJourneyCourse) {
          //console.dir(this.Controller.JourneyCourse.currentJourneyCourse);
          this.Controller.JourneyCourse.currentJourneyCourse.init();
      }
      var jid = this.Controller.JourneyCourse.currentJourneyCourse.getJid();


      Hafas('[data-journey-course-end="' + jid + '"]',false).removeAttribute("aria-hidden");
      Hafas('[data-journey-course-end="' + jid + '"]',false).removeAttribute("hidden");

      Hafas('[data-journey-course-start="' + jid + '"]',false).setAttribute("aria-hidden","hidden");
      Hafas('[data-journey-course-start="' + jid + '"]',false).setAttribute("hidden",true);
  },
  openJourneyCourse: function(type,data){
     Hafas('.hfs_journeyCourseContainer',true).forEach(function(elem){
         elem.parentNode.removeChild(elem);
     });

     var journeyCourseWrap = document.createElement("div");
     journeyCourseWrap.id = "journeyCourseContainer";
     journeyCourseWrap.className = "hfs_journeyCourseContainer";
     this.journeyCourseContainer = journeyCourseWrap;

     document.body.appendChild(journeyCourseWrap);

     if(this.currentJourneyCourse) {
        this.currentJourneyCourse.stopanimation();
     }


     Hafas.Modules.Render.render(
         {
           file: 'journeycourse.index.html',
           template: 'journeycourse_canvas',
           target: journeyCourseWrap,
           model: {
               id: data.jid,
               iconResolved: data.iconResolved,
               productName: data.productName,
               fg: data.fg,
               bg: data.bg,
               dirTxt: data.dirTxt
           }
         },Hafas.bind(function(html){
               var journeyCourseCanvas = Hafas('[data-journey-course-id="' + data.jid + '"]',false);
               var jnyCourseOpts = {
                      div: journeyCourseCanvas,
                      jid: data.jid,
                      showLabels: true,
                      arrJourneys: true
               };
               if(typeof data.locFltr != 'undefined') {
                   jnyCourseOpts.locFltr = data.locFltr;
               }
               if(typeof data.lineFltr != 'undefined') {
                   jnyCourseOpts.lineFltr = data.lineFltr;
               }
               if(typeof data.pCls != 'undefined') {
                   jnyCourseOpts.pCls = data.pCls;
               }
               if(typeof data.dir != 'undefined') {
                   jnyCourseOpts.dir = data.dir;
               }
               jnyCourseOpts.initCall = false;
               this.Controller.JourneyCourse.currentJourneyCourse = Hafas.Core.newType("hafasJourneyCourse",jnyCourseOpts);
         },this))



     var _me = this.Controller.JourneyCourse;
  },
  closeJourneyCourse: function(){
       if(this.currentJourneyCourse) {
         this.currentJourneyCourse.stopanimation();
         this.currentJourneyCourse = null;
       }
       if(this.journeyCourseContainer != null) {
          this.journeyCourseContainer.parentNode.removeChild(this.journeyCourseContainer);
       }
       this.Controller.Livemap.stopLivemap(true);
       this.Controller.Livemap.instance.setJourneyFilter(null);
  },
  addLivemap: function(trainData){
     if(Hafas.Config.Switches.useLivemap){
     var jnyIds = [];
     for(var t in trainData) {
         jnyIds.push(t);
     }
     this.Controller.Livemap.startLivemap({jnyFltr:jnyIds});
  }
}
}



